// extracted by mini-css-extract-plugin
export var errorIcon = "_li-1";
export var nameLogo = "_li-0";